// core/meeting-statuses.mjs — the meeting status registry, in ONE place.
//
// ⚠️ THE PARTITION IS THE POINT. `MEETING_ACTIVE` and `MEETING_FINISHED` are not "the
// interesting statuses" — the Desk's Active filter (where agents live ~95% of the time) shows
// the first list and the Finished filter shows the second, so a status in NEITHER is in NO
// view: the meeting silently ceases to exist for its own agent. That is not hypothetical. It
// happened on 2026-08-03, when `rescheduled` shipped as a sixth status and the first meeting
// marked with it vanished; `MeetingCountdown` had the same hole for `cancelled` since 0396.
//
// Until now the rule was enforced by a comment asking people to remember. It is a test now
// (`meeting-statuses.test.mjs`), which is why the lists live in a plain .mjs the test runner
// can import — `MeetingsFeed.jsx` re-exports them, so every existing importer is unaffected.
//
// ⚠️ Two more copies of this list exist and are NOT yet derived from here: `STATUSES` in
// `server-new-libs/lib/core_meeting.js` (the write-path allowlist) and `STATUSES` in
// `DealsTab.jsx` (the legacy surface). Keeping them in step is still manual — the test below
// at least guarantees that whatever this file says is internally coherent.

/** Every status a meeting row may store. The server's write path accepts exactly these. */
export const MEETING_STATUSES = [
  'scheduled', 'pending', 'binder', 'closed', 'failed', 'rescheduled', 'cancelled',
]

/** Still in play — the Desk's default view. */
export const MEETING_ACTIVE = ['scheduled', 'pending', 'binder', 'rescheduled']

/** Over, one way or another. `cancelled` is a NON-outcome (the hour was given back),
 *  `failed` is a real outcome that produced nothing — they are deliberately separate. */
export const MEETING_FINISHED = ['closed', 'failed', 'cancelled']
